import dayjs from 'dayjs'
import { Box, Typography } from '@astro-ui/components'
import * as S from '../../DatePickerStyled'

export type MonthPickerPropsType = {
  monthSelected: number | null
  setMonthSelected: React.Dispatch<React.SetStateAction<number | null>>
  yearSelected: number
  setYearSelected: React.Dispatch<React.SetStateAction<number>>
  minDate?: Date
  maxDate?: Date
}

const monthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

function isMonthDisabled(
  year: number,
  monthIndex: number,
  minDate?: Date,
  maxDate?: Date,
): boolean {
  const monthStart = dayjs().year(year).month(monthIndex).startOf('month')
  return (
    (!!minDate && monthStart.isBefore(dayjs(minDate).startOf('month'))) ||
    (!!maxDate && monthStart.isAfter(dayjs(maxDate).endOf('month')))
  )
}

function MonthPicker({
  monthSelected,
  setMonthSelected,
  yearSelected,
  setYearSelected,
  minDate,
  maxDate,
}: MonthPickerPropsType) {
  const minYear = minDate ? dayjs(minDate).year() : undefined
  const maxYear = maxDate ? dayjs(maxDate).year() : undefined
  const isPrevYearDisabled = minYear !== undefined && yearSelected <= minYear
  const isNextYearDisabled = maxYear !== undefined && yearSelected >= maxYear

  return (
    <Box width="340px">
      <Box width="100%" display="flex" justifyContent="space-between" p="32px 0 24px">
        <button
          type="button"
          aria-label="btnDatepickerPrev"
          className="rdrNextPrevButton rdrPprevButton"
          disabled={isPrevYearDisabled}
          onClick={() => !isPrevYearDisabled && setYearSelected((prev) => prev - 1)}
        >
          <i />
        </button>
        <Typography variant="body1">{yearSelected}</Typography>
        <button
          aria-label="btnDatepickerNext"
          type="button"
          className="rdrNextPrevButton rdrNextButton"
          disabled={isNextYearDisabled}
          onClick={() => !isNextYearDisabled && setYearSelected((prev) => prev + 1)}
        >
          <i />
        </button>
      </Box>
      <Box display="flex" gap="12px" flexWrap="wrap" p="0 8px" mb="24px">
        {monthList.map((item, index) => {
          const disabled = isMonthDisabled(yearSelected, index, minDate, maxDate)
          return (
            <S.MonthCard
              key={item}
              selected={monthSelected === index}
              disabled={disabled}
              onClick={() => !disabled && setMonthSelected(index)}
            >
              <Typography variant="h5" color={monthSelected === index ? 'white' : 'grey7'}>
                {item}
              </Typography>
            </S.MonthCard>
          )
        })}
      </Box>
    </Box>
  )
}

export default MonthPicker
